import React, {useContext} from "react";
import {Image} from "react-native";
import Div from "../lib/Div";
import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import MainStyle from "../../MainStyle";
import logo from "../assets/img/icons/FullSwingLogo.svg";
import logo2 from "../assets/img/Full Swing Sports Logo V2.png";
import FSSSLogo from "../assets/img/icons/full swing skill strike logo.svg";
import FSSSLogo2 from "../assets/img/icons/Full Swing Skill Strike logo_white 2.svg";
import P from "../lib/P";
import {useNavigation} from "@react-navigation/native";
import Btn from "./Btn";
import AntDesign from "@expo/vector-icons/AntDesign";
import {Ionicons} from "@expo/vector-icons";
import {LinearGradient} from "expo-linear-gradient";
import BalanceButton from "./BalanceButton";
import {StoreContext} from "./StoreContextProvider";
import {NativeStackNavigationProp} from "@react-navigation/native-stack";
import MenuModal from "../modals/MenuModal";
import FullSwingProfileModal from "../modals/FullSwingProfileModal";

type Props = {
  px?: number, title?: string, goBack?: () => void, hideLogo?: boolean, onCancel?: () => void, hideAccount?: boolean,
  hideMenu?: boolean, hideGameLogo?: boolean, hideBalance?: boolean, redesignEnabled?: boolean
};

const FSHeader = (props: Props) => {
  const {px, title, hideLogo, hideAccount, hideMenu, hideGameLogo, hideBalance, redesignEnabled} = props;
  const Context = useContext(StoreContext);
  const navigation: NativeStackNavigationProp<any> = useNavigation();

  return (
    <LinearGradient colors={["#131314", "#252526"]} start={{x: 0, y: 1}} end={{x: 0, y: 0}}
                    style={[{paddingHorizontal: px}, MainStyle.p_y_12, MainStyle.row, MainStyle.a_i_c]}>
      {props.goBack ? (
        <Btn w={28} h={28} bg="#252526" onPress={props.goBack} alignItems="center" justifyContent="center"
             rounded={15}>
          <Ionicons name="chevron-back" size={24} color="white"/>
        </Btn>
      ) : props.onCancel ? <Div w={28} h={28}/> : null}

      {redesignEnabled ? (
        <Div flex={1} column gap={12}>
          <Div row alignItems="center" justifyContent="space-between">
            <Btn testID="header-user-icon" w={28} h={28} rounded={20} alignItems="center" justifyContent="center"
                 bg="rgb(37,37,38)" onPress={() => Context.setShowProfileModal(true)}>
              <FontAwesome5 name="user" size={15} color="white"/>
            </Btn>

            <Btn mx="auto" onPress={() => navigation.navigate('challenges')}>
              <Image source={logo2 as any} style={[MainStyle.h_20, MainStyle.w_107]}/>
            </Btn>

            <MenuModal/>
          </Div>

          <Image source={FSSSLogo2 as any} style={[MainStyle.h_13, MainStyle.w_170, MainStyle.m_x_auto]}/>
        </Div>
      ) : (
        <Div column gap={12} flex={1}>
          {(!hideAccount || !hideLogo || !hideMenu) && (
            <Div row alignItems="center" justifyContent="space-between">
              {!hideAccount ? (
                <Btn testID="header-user-icon" w={28} h={28} rounded={20} alignItems="center" justifyContent="center"
                     bg="rgb(37,37,38)" onPress={() => Context.setShowProfileModal(true)}>
                  <FontAwesome5 name="user" size={15} color="white"/>
                </Btn>
              ) : !hideMenu ? <Div w={28} h={28}/> : null}

              {!hideLogo && (
                <Btn mx="auto" onPress={() => navigation.navigate('challenges')}>
                  <Image source={logo as any} style={[MainStyle.h_14, MainStyle.w_168]}/>
                </Btn>
              )}

              {!hideMenu ? <MenuModal/> : !hideAccount ? <Div w={28} h={28}/> : null}
            </Div>
          )}

          <Div row justifyContent="space-between" alignItems="center">
            {!hideGameLogo ? (
              <Image source={FSSSLogo as any} style={[MainStyle.h_10, MainStyle.w_130]}/>
            ) : !!title && !hideBalance ? (
              <BalanceButton opacity={0}/>
            ) : null}

            {title && <P flex={1} fontFamily="DavisSans-Medium" fs={20} lh={30} ta="center">{title}</P>}

            {!hideBalance && <BalanceButton/>}
          </Div>
        </Div>
      )}

      {props.onCancel ? (
        <Btn w={28} h={28} bg="#252526" onPress={props.onCancel} alignItems="center" justifyContent="center"
             rounded={15}>
          <AntDesign name="close" size={16} color="white"/>
        </Btn>
      ) : props.goBack ? <Div w={28} h={28}/> : null}

      <FullSwingProfileModal visible={Context.showProfileModal}
                             onClose={() => Context.setShowProfileModal(false)}/>
    </LinearGradient>
  );
};

export default FSHeader;
